import {UISidebarController} from '../../../ui_html/sidebar/UISidebarController'

export class UIDValuesExamplesSceneController {
    private readonly sidebarController: UISidebarController
    private readonly valuesExamplesSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.valuesExamplesSceneContainerDiv = document.getElementById('scene_discord_values_examples_container') as HTMLDivElement
    }

    hide() {
        this.valuesExamplesSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.valuesExamplesSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
